import { render, staticRenderFns } from "./WelcomeToOliver.vue?vue&type=template&id=2901aa18"
import script from "./WelcomeToOliver.vue?vue&type=script&lang=js"
export * from "./WelcomeToOliver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports